export default __webpack_public_path__ + "static/media/trafic-gallery-4.c982f4dd.jpg";